/**
 * FUNCTION: isLegal
 * SUMMARY: Determine if the node passed in is a legal embedded inline entry.
 * @param {Object} node
 * @returns {Boolean}
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var isLegal = function (node) {
    var _a, _b, _c;
    return node.nodeType === 'embedded-entry-inline' &&
        ((_c = (_b = (_a = node.data.target) === null || _a === void 0 ? void 0 : _a.sys) === null || _b === void 0 ? void 0 : _b.contentType) === null || _c === void 0 ? void 0 : _c.sys.id) === 'legal';
};
export var isDrawer = function (node) {
    var _a, _b, _c;
    return node.nodeType === 'embedded-entry-inline' &&
        ((_c = (_b = (_a = node.data.target) === null || _a === void 0 ? void 0 : _a.sys) === null || _b === void 0 ? void 0 : _b.contentType) === null || _c === void 0 ? void 0 : _c.sys.id) === 'drawer';
};
export var isOneTrustPreferences = function (node) {
    var _a, _b, _c;
    return node.nodeType === 'embedded-entry-inline' &&
        ((_c = (_b = (_a = node.data.target) === null || _a === void 0 ? void 0 : _a.sys) === null || _b === void 0 ? void 0 : _b.contentType) === null || _c === void 0 ? void 0 : _c.sys.id) === 'oneTrustPreferences';
};
export var isUDSLegal = function (node) {
    var legalPattern = /\${LEGAL\.|_LEGAL\./;
    return legalPattern.test(node);
};
var paragraphSizeNodeTypes = ['paragraph', 'hyperlink'];
var ineligibleNodeType = ['text'];
/**
 * Summary: This function recursively loops through a richtext object and returns an array of all legal objects with correct comma placement and font size.
 * @param object - content object associated with RichText
 * @param fontSizes -  an object outlining the font sizes associated with the heading, paragraph, and list elements
 * @param legals - an array of legal objects to be returned from the function
 * @param prevObject - the previous object in the recursion process
 * @returns legals object
 */
export var getLegalEntries = function (object, fontSizes, legals, prevObject) {
    var _a;
    if (fontSizes === void 0) { fontSizes = {}; }
    if (legals === void 0) { legals = []; }
    if (prevObject === void 0) { prevObject = {}; }
    (_a = object === null || object === void 0 ? void 0 : object.content) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
        // if it's not an eligible not type then don't add it to the legals array
        if (!(ineligibleNodeType.includes(item.nodeType) || item.value === '')) {
            if (isLegal(item)) {
                // if it is a legal item then add it to the legals array with the corresponding font size and comma placement
                legals = getLegalItem(item, fontSizes, legals, prevObject);
            }
            prevObject = item;
            // recursively search through the entire object and its children
            getLegalEntries(item, fontSizes, legals, prevObject);
        }
    });
    return legals;
};
var getLegalItem = function (item, fontSizes, legals, prevObject) {
    var _a;
    if (fontSizes === void 0) { fontSizes = {}; }
    if (legals === void 0) { legals = []; }
    if (prevObject === void 0) { prevObject = {}; }
    // if there is a previous legal item from the the recursion process then add a comma to the previous legal item
    var lastLegalItem;
    if (isLegal(prevObject)) {
        lastLegalItem = legals[legals.length - 1];
        lastLegalItem.addComma = true;
    }
    // add the legal item to the legals array with the corresponding font size and comma placement
    legals.push(__assign(__assign({}, item), { addComma: false, size: (_a = lastLegalItem === null || lastLegalItem === void 0 ? void 0 : lastLegalItem.size) !== null && _a !== void 0 ? _a : getLegalFontSize(fontSizes, prevObject) }));
    return legals;
};
var getLegalFontSize = function (fontSizes, prevObject) {
    var _a;
    if (fontSizes === void 0) { fontSizes = {}; }
    if (prevObject === void 0) { prevObject = {}; }
    var headingSize = fontSizes.headingSize, paragraphSize = fontSizes.paragraphSize;
    var prevNode = prevObject.nodeType;
    // default font size
    var legalFontSize = 'medium';
    var isParagraph = paragraphSizeNodeTypes.includes(prevNode);
    var isHeading = typeof prevNode === 'string' && /^heading-(1|2|3|4|5|6)$/.test(prevNode);
    // set the font size for the legal item based on the previous node type using the `legalFontSizeValues` dictionary object
    if (isHeading) {
        var headingType = "h".concat(prevNode.slice(-1));
        legalFontSize = (_a = headingSize === null || headingSize === void 0 ? void 0 : headingSize[headingType]) !== null && _a !== void 0 ? _a : headingType;
    }
    else if (isParagraph && paragraphSize)
        legalFontSize = paragraphSize;
    return legalFontSize;
};
